import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  routesFirstWay: [],
  routesSecondWay: [],
  anotherWayRoutes: [],
  unchangedRoutes: null,
  filter: { type: 0, search: "" },
  activeTab: 0,
  isOpenedRouteModal: false,

  // CREATE ROUTE
  createRouteLoading: false,
  createRouteError: false,

  // UPDATE ROUTE
  updateRouteLoading: false,
  updateRouteError: null,

  // GET ALL ROUTES
  routesLoading: false,
  routesError: null,

  // GET ROUTES BY ROUTE ID
  routesByRouteIdLoading: false,
  routesByRouteId: [],
  routesByRouteIdError: null,

  // UPDATE ROUTE ORDER
  updateRouteOrderLoading: false,
  updateRouteOrderError: null,

  // UPDATE ROUTE AS SENT
  updateRouteAsSentLoading: false,
  updateRouteAsSentError: null,

  //CANCELLED ROUTES
  cancelledRoutesLoading: false,
  cancelledRoutes: [],
  cancelledRoutesError: null,

  //CREATE MARKER
  createMarkerLoading: false,
  createMarkerError: null,

  //DELETE MARKER
  deleteMarkerLoading: false,
  deleteMarkerError: null,

  //SOFT DELETE ROUTE
  softDeleteRouteLoading: false,
  softDeleteRouteReturnReservationFlag: null,
  softDeleteRouteReturnReservation: null,
  softDeleteRouteError: null,
};

export const routeSlice = createSlice({
  name: "route",
  initialState,
  reducers: {
    resetState: (state) => {
      state.routesFirstWay = [];
      state.routesSecondWay = [];
      state.createRouteLoading = false;
      state.createRouteError = null;
    },
    reorderRoutes: (state, action) => {
      if (state.unchangedRoutes === null) {
        if (action.payload.way === false) {
          state.unchangedRoutes = {
            firstWay: [...state.routesFirstWay],
            secondWay: [],
          };
          state.routesFirstWay = [...action.payload.tmpArr];
        } else {
          state.unchangedRoutes = {
            firstWay: [],
            secondWay: [...state.routesSecondWay],
          };
          state.routesSecondWay = [...action.payload.tmpArr];
        }
      } else {
        if (action.payload.way === false) {
          state.unchangedRoutes = {
            ...state.unchangedRoutes,
            firstWay: [...state.routesFirstWay],
          };
          state.routesFirstWay = [...action.payload.tmpArr];
        } else {
          state.unchangedRoutes = {
            ...state.unchangedRoutes,
            secondWay: [...state.routesSecondWay],
          };
          state.routesSecondWay = [...action.payload.tmpArr];
        }
      }
    },
    resetReorderedRoutes: (state, action) => {
      if (!action.payload.way) {
        state.routesFirstWay = [...state.unchangedRoutes.firstWay];
      } else {
        state.routesSecondWay = [...state.unchangedRoutes.secondWay];
      }
    },
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
    resetFilter: (state) => {
      state.filter = { type: 0, search: "" };
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    toggleRouteModal: (state) => {
      state.isOpenedRouteModal = !state.isOpenedRouteModal;
      if (state.isOpenedRouteModal === true) {
        state.routesByRouteIdLoading = false;
        state.routesByRouteId = [];
        state.routesByRouteIdError = null;
      }
    },
    resetSoftDeleteRouteReturnReservationId: (state) => {
      state.softDeleteRouteReturnReservationFlag = false;
      state.softDeleteRouteReturnReservation = null;
    },

    // CREATE ROUTE
    createRoutePost: (state) => {
      state.createRouteLoading = true;
      state.createRouteError = null;
    },
    createRouteSuccess: (state, action) => {
      state.createRouteLoading = false;
      // state.routes = [...state.routes, ...action.payload];
      state.createRouteError = null;
    },
    createRouteError: (state, action) => {
      state.createRouteLoading = false;
      state.createRouteError = action.payload;
    },

    // UPDATE ROUTE
    updateRoutePut: (state) => {
      state.updateRouteLoading = true;
      state.updateRouteError = null;
    },
    updateRouteSuccess: (state, action) => {
      state.updateRouteLoading = false;
      // state.routes = [...state.routes, ...action.payload];
      state.updateRouteError = null;
    },
    updateRouteError: (state, action) => {
      state.updateRouteLoading = false;
      state.updateRouteError = action.payload;
    },

    // UPDATE ROUTE AS SENT
    updateRouteAsSentPut: (state) => {
      state.updateRouteAsSentLoading = true;
      state.updateRouteAsSentError = null;
    },
    updateRouteAsSentSuccess: (state) => {
      state.updateRouteAsSentLoading = false;
      state.updateRouteAsSentError = null;
    },
    updateRouteAsSentError: (state, action) => {
      state.updateRouteAsSentLoading = false;
      state.updateRouteAsSentError = action.payload;
    },

    // GET ALL ROUTES
    getRoutesFetch: (state) => {
      state.routesLoading = true;
      state.routes = [];
      state.routesError = null;
    },
    getRoutesSuccess: (state, action) => {
      state.routesLoading = false;
      state.routes = action.payload;
      state.routesError = null;
    },
    getRoutesError: (state, action) => {
      state.routesLoading = false;
      state.routes = [];
      state.routesError = action.payload;
    },

    // GET ROUTES BY ROUTE ID
    getRoutesByRouteIdFetch: (state) => {
      state.routesByRouteIdLoading = true;
      state.routesByRouteId = [];
      state.routesByRouteIdError = null;
    },
    getRoutesByRouteIdSuccess: (state, action) => {
      state.routesByRouteIdLoading = false;
      state.routesByRouteId = action.payload;
      state.routesByRouteIdError = null;
    },
    getRoutesByRouteIdError: (state, action) => {
      state.routesByRouteIdLoading = false;
      state.routesByRouteId = [];
      state.routesByRouteIdError = action.payload;
    },

    // GET ALL ROUTES BY DESTINATION TYPE
    getRoutesByDestinationTypeFetch: (state) => {
      state.routesLoading = true;
      state.routesFirstWay = [];
      state.routesSecondWay = [];
      state.routesError = null;
    },
    getRoutesByDestinationTypeSuccess: (state, action) => {
      state.routesLoading = false;
      state.routesFirstWay = action.payload.firstWay;
      state.routesSecondWay = action.payload.secondWay;
      state.routesError = null;
    },
    getRoutesByDestinationTypeError: (state, action) => {
      state.routesLoading = false;
      state.routesFirstWay = [];
      state.routesSecondWay = [];
      state.routesError = action.payload;
    },

    // UPDATE ROUTE ORDER
    updateRouteOrderPut: (state) => {
      state.updateRouteOrderLoading = true;
      state.updateRouteOrderError = null;
    },
    updateRouteOrderSuccess: (state, action) => {
      state.updateRouteOrderLoading = false;
      state.routesFirstWay = action.payload.firstWay;
      state.routesSecondWay = action.payload.secondWay;
      state.unchangedRoutes = null;
      state.updateRouteOrderError = null;
    },
    updateRouteOrderError: (state, action) => {
      state.updateRouteOrderLoading = false;
      state.updateRouteOrderError = action.payload;
    },

    // CANCELLED ROUTES
    getCancelledRoutesFetch: (state) => {
      state.cancelledRoutesLoading = true;
      state.cancelledRoutes = [];
      state.cancelledRoutesError = null;
    },
    getCancelledRoutesSuccess: (state, action) => {
      state.cancelledRoutesLoading = false;
      state.cancelledRoutes = action.payload;
      state.cancelledRoutesError = null;
    },
    getCancelledRoutesError: (state, action) => {
      state.cancelledRoutesLoading = false;
      state.cancelledRoutes = [];
      state.cancelledRoutesError = action.payload;
    },

    // CREATE MARKER
    createMarker: (state) => {
      state.createMarkerLoading = true;
      state.createMarkerError = null;
    },
    createMarkerSuccess: (state) => {
      state.createMarkerLoading = false;
      state.createMarkerError = null;
    },
    createMarkerError: (state, action) => {
      state.createMarkerLoading = false;
      state.createMarkerError = action.payload;
    },

    // DELETE MARKER
    deleteMarker: (state) => {
      state.deleteMarkerLoading = true;
      state.deleteMarkerError = null;
    },
    deleteMarkerSuccess: (state) => {
      state.deleteMarkerLoading = false;
      state.deleteMarkerError = null;
    },
    deleteMarkerError: (state, action) => {
      state.deleteMarkerLoading = false;
      state.deleteMarkerError = action.payload;
    },

    // SOFT DELETE ROUTE
    softDeleteRouteFetch: (state) => {
      state.softDeleteRouteLoading = true;
      state.softDeleteRouteReturnReservationFlag = null;
      state.softDeleteRouteReturnReservation = null;
      state.softDeleteRouteError = null;
    },
    softDeleteRouteSuccess: (state, action) => {
      state.softDeleteRouteLoading = false;

      if (action.payload && action.payload.id > 0) {
        state.softDeleteRouteReturnReservationFlag = true;
        state.softDeleteRouteReturnReservation = action.payload;
      } else {
        state.softDeleteRouteReturnReservationFlag = false;
      }
      state.softDeleteRouteError = null;
    },
    softDeleteRouteError: (state, action) => {
      state.softDeleteRouteLoading = false;
      state.softDeleteRouteReturnReservationFlag = null;
      state.softDeleteRouteReturnReservation = null;
      state.softDeleteRouteError = action.payload;
    },
  },
});

export const routeActions = routeSlice.actions;
export const routeReducers = routeSlice.reducer;
